<section class="page">
    <div class="container">
        <div class="d-flex flex-wrap justify-content-between align-items-center">
            <h1 class="page-title">{{ "HOME.LATEST-VIDEOS" | translate }}</h1>
            <app-shared-filter [filter]="filters" (onChange)="onFilterChange($event)"></app-shared-filter>
        </div>
        <div *ngIf="statusCode == 0" class="row">
            <!-- prettier-ignore -->
            <div
                class="col-lg-4 mb-4"
                *ngFor="let video of registers | slice : (page - 1) * perPage : (page - 1) * perPage + perPage"
            >
                <div class="video-card">
                    <img
                        class="video-image"
                        [src]="video.videos[0].url_capa"
                        [alt]="video.title"
                    />
                    <h3 class="video-title">
                        {{ video.title }}
                    </h3>
                    <a
                        class="video-link"
                        [href]="video.videos[0].url_video"
                        target="_blank"
                        rel="noopener noreferrer"
                    ></a>
                </div>
            </div>
        </div>
        <app-shared-pagination
            [perPage]="perPage"
            [size]="registers?.length"
            (onChange)="onPageChange($event)"
            *ngIf="registers?.length"
        ></app-shared-pagination>
        <ng-container *ngIf="!registers">
            <h2 class="not-found">
                Ops!
                <br />
                <span>{{ "MESSAGE.RESULT.TRANSACTION-WITHOUT-RETURN" | translate }}</span>
            </h2>
        </ng-container>
    </div>
</section>
